import {
	tree
} from "d3";

const debounce = (fn, delay) => {
	let timer;
	return function() {
		if (timer) {
			clearTimeout(timer);
		}
		timer = setTimeout(() => {
			fn();
		}, delay);
	}
};
const cancalDebounce = debounce(getWindowInfo, 500);

function getWindowInfo() {
	console.log(document.body.clientWidth, window.screen.availWidth)
	let isFull = document.fullscreenElement ? true : false;
	if (!isFull) {
		// window.location.reload()
	}
};
const checkFull = () => {
	let isFull = document.fullscreenElement ? true : false;
	if (isFull === undefined || isFull === null) isFull = false;
	return isFull;
};
// 监听网页大小变化
window.addEventListener('resize', cancalDebounce);
// 禁用f12
document.onkeydown = function() {

	if (window.event && window.event.keyCode == 123) {
		return false;
		// alert("F12被禁用");
		event.keyCode = 0;
		event.returnValue = false;
	}
	if (window.event && window.event.keyCode == 13) {
		return false;
		window.event.keyCode = 505;
	}
	if (window.event && window.event.keyCode == 8) {
		// return false;
		// alert(str+"\n请使用Del键进行字符的删除操作！");
		// window.event.returnValue = false;
	}

}
// 禁用右键菜单
document.oncontextmenu = function(event) {
	if (window.event) {
		event = window.event;
	}
	try {
		var the = event.srcElement;
		if (!((the.tagName == "INPUT" && the.type.toLowerCase() == "text") || the.tagName == "TEXTAREA")) {
			return false;
		}
		return true;
	} catch (e) {
		return false;
	}
}